import { type UseModalState } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";
import { FullScreenDialog } from "@src/appV2/lib";
import { FullScreenDialogTitle } from "@src/appV2/lib/Dialogs/FullScreen/DialogTitle";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useHistory } from "react-router-dom";

export interface RecordVideoPageProps {
  modalState: UseModalState;
  workplaceId: string;
  workplaceName: string;
}

export function RecordVideoPage(props: RecordVideoPageProps) {
  const { modalState, workplaceId, workplaceName } = props;

  const worker = useDefinedWorker();
  const history = useHistory();
  const { _id: workerId, firstName: workerName } = worker;

  const maxDuration = 60;
  const iframeUrl = new URL("https://social-v0-production.up.railway.app");

  iframeUrl.searchParams.set("workerId", workerId);
  iframeUrl.searchParams.set("workerName", workerName ?? "");
  iframeUrl.searchParams.set("workplaceId", workplaceId);
  iframeUrl.searchParams.set("workplaceName", workplaceName);
  iframeUrl.searchParams.set("maxDuration", maxDuration.toString());

  /* eslint-disable react/iframe-missing-sandbox */
  return (
    <FullScreenDialog modalState={modalState}>
      <FullScreenDialogTitle
        onClose={() => {
          history.goBack();
        }}
      >
        Record Video
      </FullScreenDialogTitle>

      <Box height="100%" position="relative">
        <iframe
          allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
          src={iframeUrl.toString()}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
          }}
          title="recordVideo"
        />
      </Box>
    </FullScreenDialog>
    /* eslint-enable react/iframe-missing-sandbox */
  );
}
